import { saveTokens } from './tokens';
import { verifyTokenIdentity } from './verify';
/** Returns true when called on a fresh redirect that carries tokens in the hash. */
export function handleAuthCallback() {
    const hash = window.location.hash;
    if (!hash || !hash.includes('access_token='))
        return false;
    const params = new URLSearchParams(hash.substring(1));
    const access = params.get('access_token');
    const refresh = params.get('refresh_token');
    if (!access)
        return false;
    saveTokens(access, refresh);
    void verifyTokenIdentity(access);
    history.replaceState(null, '', window.location.pathname + window.location.search);
    return true;
}
